import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useTheme } from '@/composables/useTheme'

export const useAppStore = defineStore('app', () => {
  const { theme, initTheme, toggleTheme } = useTheme()

  const sidebarCollapsed = ref(false)

  function toggleSidebar(): void {
    sidebarCollapsed.value = !sidebarCollapsed.value
  }

  function initApp(): void {
    initTheme()
  }

  return {
    theme,
    sidebarCollapsed,
    toggleSidebar,
    toggleTheme,
    initApp
  }
})
